import cookies from 'js-cookie'
export default function payforarr(path,arr) {
    const payforList = arr || JSON.parse( cookies.get('payforarr'))
    const payfor = payforList.filter(a=> a.path_info === path)
    return  payfor[0]
}


// WEBPACK FOOTER //
// ./src/utils/getpayfor.js